import React from "react";
import { Row } from "reactstrap";
import { Speaking } from "../quiz/speaking";
import { ShowQuestions } from "../quiz/ShowQuestions";
import { TextArea } from "./../../components/writting_essay/textarea";
import { exerciseType } from "../../components/constants/constants";
import B2CDescription from "./B2C_Description";
import { B2CAssessmentFeedback } from "./B2C_AssessmentFeedback";

export const B2CMobileAssessment = ({
  exercise,
  isReview,
  setIsonRecorder,
  setSpeakingUrl,
  currentPage,
  resetAudio,
  setresetAudio,
  onblur,
  answers,
  section_id,
  page_id,
  data,
  text_area_date,
  handleCopyPaste,
  textarea_change,
  Answerslength,
  wordsCounter,
  observedDiv,
}) => {
  return (
    <div ref={observedDiv}>
      {exercise.html_content && (
        <Row className="bg-white b2c-p-3 py-3 mb-4 b2c-border-light">
          <B2CDescription
            description={
              <div
                spellcheck="false"
                data-gramm="false"
                dangerouslySetInnerHTML={{
                  __html: `${exercise.html_content
                    .replace(/\[\[.*?\]\]\.\s*/g, "")
                    .replace(/\[\[.*?\]\]\s*/g, "")}`,
                }}
              />
            }
          />
        </Row>
      )}
      {exercise.task_type === exerciseType.WRITING_TASK ? (
        <div key={exercise.id}>
          <Row className="bg-white b2c-p-3 py-3 b2c-border-light">
            <TextArea
              data-question-type="writing"
              data-tc="writitng-text"
              data-section-id={section_id}
              data-page-id={page_id}
              data-exercise-id={exercise.id}
              defaultValue={text_area_date}
              onCopy={handleCopyPaste}
              onPaste={handleCopyPaste}
              value={isReview ? exercise.answers : null}
              onchange={textarea_change}
              onBlur={onblur}
            />
            <Row
              className="bg-white px-4 py-2 g-0 border-top"
              key={`${page_id}${section_id}${exercise.id}`}
            >
              <span className="text-muted">
                {" "}
                Words: {Answerslength === 0 ? Answerslength : wordsCounter}{" "}
                words{" "}
              </span>
            </Row>
          </Row>
        </div>
      ) : (
        <Row
          key={exercise.id}
          className="bg-white b2c-p-3 py-3 b2c-border-light"
        >
          {exercise.task_type === "Speaking Task" ||
          exercise.task_type === exerciseType.PRONUNCIATION_TASK ? (
            <Speaking
              speakingUrl={setSpeakingUrl}
              setIsonRecorder={setIsonRecorder}
              data_section_id={section_id}
              data_page_id={page_id}
              answers={answers}
              resetAudio={resetAudio}
              setresetAudio={setresetAudio}
              data_exercise_id={exercise.id}
              data_type={data.type}
              speaking_data={exercise.speaking_plain_text_for_ml}
              isReview={isReview}
              speakingResponseURL={exercise.listening_file_url}
              Studentname={data.school_student_name}
            />
          ) : (
            <div>
              <ShowQuestions
                exercise_id={exercise.id}
                section_id={section_id}
                page_id={page_id}
                questions={exercise.questions}
                task_type={exercise.task_type}
                currentPage={currentPage}
                onAnswer={onblur}
                isReview={isReview}
                answer={answers}
                status={exercise.status}
                data={data}
                ai_grading_exercise={exercise.ai_grading_task}
              />
            </div>
          )}
        </Row>
      )}
      {isReview &&
        exercise.task_type !== exerciseType.WRITING_TASK &&
        exercise.questions  && exercise.questions?.length === 1 &&
        (exercise.questions[0].ai_feedback || exercise.ai_grading_task) && (
          <Row
            key={exercise.id}
            className= "bg-white b2c-p-3 py-3 b2c-border-light mt-4"
          >
            <div>
              <B2CAssessmentFeedback
                questions={exercise.questions}
                currentPage={currentPage}
                isReview={isReview}
                status={exercise.status}
                ai_grading_exercise={exercise.ai_grading_task}
              />
            </div>
          </Row>
        )}
    </div>
  );
};
